import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { AssignUserRoles, UserWithRoles } from '@dcc-erp/shared';

import { api, apiJson } from '../api';

const key = (companyId: string | undefined) => ['company-users', companyId] as const;

export function useCompanyUsers(companyId: string | undefined) {
  return useQuery({
    queryKey: key(companyId),
    queryFn: () => api<UserWithRoles[]>(`/companies/${companyId}/users`),
    enabled: !!companyId,
  });
}

export function useAssignUserRoles(companyId: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, data }: { userId: string; data: AssignUserRoles }) => {
      if (!companyId) throw new Error('useAssignUserRoles: companyId is required');
      return apiJson<AssignUserRoles, unknown>(
        'PUT',
        `/companies/${companyId}/users/${userId}/roles`,
        data,
      );
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: key(companyId) });
      void qc.invalidateQueries({ queryKey: ['me'] });
    },
  });
}
